var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('read-more',{staticClass:"block-tekst",attrs:{"more-str":_vm.readMoreText,"less-str":_vm.readLessText,"text":_vm.content,"max-chars":_vm.value.Collapse ? 700 : 1000000,"link":"#"}})}
var staticRenderFns = []

export { render, staticRenderFns }